import {ActionTypes} from "./types";

const INITIAL_STATE = {
  zendeskTickets: undefined
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_ZENDESK_TICKETS:
      return {
        ...state,
        zendeskTickets: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;